module.exports = "<ion-app>\n  <app-menu>aaaa</app-menu>\n  <ion-router-outlet id=\"principal\" ></ion-router-outlet>\n</ion-app>\n"